function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.math.trunc.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { getScreenFromWidth } from '@finect/tabular-utils/getScreenFromWidth';
import { debounce } from '@finect/front-utils/debounce';
import { dataLayer } from '@finect/front-gtm';
import { screens } from '../Grid/utils/screens';
import { Swipe } from './Swipe';
import { Items, Item, Inner, Controls, ResizeListener, Content } from './partials';
import { getNumItemsFromBreakpoints } from './utils';
import { smoothScroll } from './utils/scroll';
import { Navigation } from './Navigation';
export var Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);
  var _super = _createSuper(Carousel);
  function Carousel() {
    var _this;
    _classCallCheck(this, Carousel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "myRef", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "itemsRef", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "lastMove", 0);
    _defineProperty(_assertThisInitialized(_this), "lastPos", 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      maxPos: 0,
      clientWidth: 1140,
      pos: 0,
      isDragging: false,
      controls: false
    });
    _defineProperty(_assertThisInitialized(_this), "getPos", function () {
      return _this.state.pos;
    });
    _defineProperty(_assertThisInitialized(_this), "getWidth", function () {
      return _this.state.clientWidth;
    });
    _defineProperty(_assertThisInitialized(_this), "getNumCards", function () {
      return _this.props.children.length;
    });
    _defineProperty(_assertThisInitialized(_this), "getNumItems", function () {
      return getNumItemsFromBreakpoints(_this.props.breakpoints, getScreenFromWidth(_this.getWidth(), screens), 4);
    });
    _defineProperty(_assertThisInitialized(_this), "getItemWidth", function () {
      return _this.props.itemWidth ? _this.props.itemWidth : _this.state.clientWidth / _this.getNumItems();
    });
    _defineProperty(_assertThisInitialized(_this), "trackEvents", function (method) {
      dataLayer({
        id: 'Carousel',
        type: 'carouselStateChange',
        params: {
          method: method,
          pos: _this.state.pos,
          maxPos: _this.state.maxPos
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handlePrev", function () {
      var gap = Math.abs(Math.trunc(_this.state.pos) - _this.state.pos);
      var newPos = _this.state.pos - 1 < 0 ? 0 : gap < 1 && gap > 0 ? Math.trunc(_this.state.pos) - 1 : Math.trunc(_this.state.pos - 1);
      _this.setState({
        isDragging: false,
        controls: true,
        pos: newPos
      }, function () {
        return _this.trackEvents('controls');
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleNext", function () {
      var newPos = _this.state.pos + 1 > _this.state.maxPos ? _this.state.maxPos : _this.state.pos + 1;
      if (newPos > _this.state.maxPos) return;
      _this.setState({
        isDragging: false,
        controls: true,
        pos: newPos
      }, function () {
        return _this.trackEvents('controls');
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleWindowResize", function () {
      _this.setState({
        controls: false,
        clientWidth: _this.myRef.current.clientWidth
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updatePos", function (event) {
      var pos = event.srcElement.scrollLeft / (_this.getItemWidth() + _this.props.itemMarginRight);
      if (_this.state.isDragging) {
        return;
      }
      _this.setState({
        controls: false,
        isDragging: false,
        pos: pos
      });
    });
    _defineProperty(_assertThisInitialized(_this), "calcConfigSet", function () {
      var clientWidth = _this.state.clientWidth;
      var itemWidth = _this.getItemWidth();
      var qty = _this.props.children.length;
      var marginPos = _this.props.itemMarginRight / itemWidth;
      var maxPos = qty - clientWidth / itemWidth + clientWidth / itemWidth * marginPos - marginPos;
      _this.setState({
        maxPos: maxPos
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseLeaveHandler", function () {});
    _defineProperty(_assertThisInitialized(_this), "onSwipeLeft", function () {
      var offset = _this.getNumItems() > 2 ? _this.getNumItems() / 2 : 1;
      var newPos = _this.getNumCards() - offset;
      if (newPos > _this.state.maxPos) return;
    });
    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (position) {
      var itemWidth = _this.getItemWidth();
      var pos = position.x / itemWidth;
      var newPos = _this.lastPos - pos;
      if (newPos <= 0) return;
      if (newPos > _this.state.maxPos) return;
      _this.setState({
        isDragging: true,
        controls: false,
        pos: newPos
      });
      _this.lastMove += Math.abs(position.x);
      return Math.abs(position.x) > Math.abs(position.y);
    });
    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function () {
      _this.lastPos = _this.state.pos;
      _this.setState({
        controls: false,
        isDragging: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "turnOffIsDragging", function () {
      setTimeout(function () {
        _this.setState({
          controls: false,
          isDragging: false
        });
        _this.lastMove = 0;
      }, 0);
    });
    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function () {
      _this.turnOffIsDragging();
      _this.trackEvents('swipe');
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      _this.lastMove && event.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickOnLink", function (event) {
      _this.lastMove && event.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "handleItemClick", function (props) {
      !_this.lastMove && _this.props.onItemClick && _this.props.onItemClick(props);
    });
    return _this;
  }
  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.setState({
        clientWidth: this.myRef.current.clientWidth
      }, function () {
        _this2.calcConfigSet();
      });
      var debouncedUpdatePos = debounce(this.updatePos, 0);
      this.itemsRef.current.addEventListener('scroll', debouncedUpdatePos);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextState.pos === 0) return true;
      if (!this.state.controls && !this.state.isDragging && !nextState.controls && !nextState.isDragging && this.state.pos !== nextState.pos) {
        return false;
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!window) {
        return;
      }
      if (prevProps.children.length !== this.props.children.length) {
        this.calcConfigSet();
      }
      if (this.state.isDragging) {
        this.itemsRef.current.scrollLeft = this.state.pos * (this.getItemWidth() + 15);
      } else if (this.state.controls) {
        smoothScroll(this.itemsRef.current, {
          left: this.state.pos * (this.getItemWidth() + 15),
          top: 0
        }, this.props.smoothScrollDuration);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        itemMarginRight = _this$props.itemMarginRight,
        alwaysShowControls = _this$props.alwaysShowControls,
        controlsSize = _this$props.controlsSize,
        controlsColor = _this$props.controlsColor;
      var pos = this.state.pos;
      var itemWidth = this.getItemWidth();
      var scrollLeft = this.itemsRef.current ? this.itemsRef.current.scrollLeft : null;
      var scrollWidth = this.itemsRef.current ? this.itemsRef.current.scrollWidth : null;
      var isRightControlVisible = !(scrollWidth - this.state.clientWidth - scrollLeft <= 0.1 * itemWidth);
      var isLeftControlVisible = pos > 0;
      return React.createElement(Inner, {
        ref: this.myRef,
        onMouseLeave: this.onMouseLeaveHandler,
        onClick: this.handleClick
      }, React.createElement(Content, null, React.createElement(Swipe, {
        allowMouseEvents: true,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        onSwipeMove: this.onSwipeMove,
        onSwipeLeft: this.onSwipeLeft,
        tolerance: 10
      }, React.createElement(Items, {
        pos: this.state.pos,
        width: itemWidth,
        ref: this.itemsRef
      }, this.props.children.map(function (element, index) {
        return React.createElement(Item, {
          onDragStart: function onDragStart(event) {
            event.preventDefault();
          },
          key: index,
          onClick: function onClick() {
            return _this3.handleItemClick(element.props);
          },
          pos: _this3.state.pos,
          itemWidth: itemWidth,
          itemMarginRight: itemMarginRight,
          isDragging: _this3.state.isDragging
        }, element);
      }))), React.createElement(Controls, {
        left: isLeftControlVisible,
        right: isRightControlVisible,
        onPrevClick: this.handlePrev,
        onNextClick: this.handleNext,
        alwaysShowControls: alwaysShowControls,
        controlsSize: controlsSize,
        controlsColor: controlsColor
      })), React.createElement(ResizeListener, {
        onChange: this.handleWindowResize
      }));
    }
  }]);
  return Carousel;
}(React.Component);
_defineProperty(Carousel, "defaultProps", {
  itemMarginRight: 15,
  smoothScrollDuration: 1100,
  alwaysShowControls: false,
  controlsSize: 'large',
  controlsColor: null
});